export default {
  autocompleteWorkFloUsages: [],
  workFloUsages: [],
  emptyWorkFloUsage: {},
  params: {
    entity: [],
    collection: []
  }
}